<template>
	<div class="newsList">
		<template v-if="headerShow">
			<div class="newsListFor" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
				<div class="newsListForTime">
					{{item.publish_time}}
				</div>
				<div class="newsListForRight">
					<div class="newsListForRightName">
						{{item.title}}
					</div>
					<div class="newsListForRightCen">
						{{item.desc}}
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="newsListFor" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
				<el-row :gutter="10">
					<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
						<div class="newsListForTime">
							{{item.publish_time}}
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
						<div class="newsListForRight">
							<div class="newsListForRightName">
								{{item.title}}
							</div>
							<div class="newsListForRightCen">
								{{item.desc}}
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Array,
				default: []
			}
		},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			goDetail(e) {
				this.$router.push({
					path: "/newsDetail",
					name: 'newsDetail',
					query: {
						id: e.id
					}
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.newsList {
		width: 100%;

		.newsListFor {
			width: 100%;
			padding-bottom: 78px;
			margin-bottom: 78px;
			border-bottom: 1px solid #E5E5E5;
			display: flex;
			cursor: pointer;

			.newsListForTime {
				margin-right: 68px;
				// font-size: 26px;
				font-size: 24px;
				
				font-weight: bold;
				color: #000000;
			}

			.newsListForRight {
				width: 0;
				flex: 1;
				padding-right: 30px;

				.newsListForRightName {
					// font-size: 26px;
					font-size: 24px;
					
					font-weight: bold;
					color: #000000;
					margin-bottom: 30px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.newsListForRightCen {
					font-size: 18px;
					
					font-weight: 400;
					color: #000000;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.newsListFor {
			display: block;
			overflow: hidden;
			padding-bottom: 30px !important;
			margin-bottom: 30px !important;
		}
		.newsListForTime{
			padding: 0 30px;
			margin-bottom: 20px !important;
			font-size: 16px !important;
		}
		.newsListForRight {
			max-width: 100vw !important;
			width: auto !important;
			word-wrap: break-word;
			word-break: break-all;
			padding: 0 30px;
			box-sizing: border-box;
			.newsListForRightName{
				font-size: 16px !important;
				// width: calc(100vw - 60px);
			}
			.newsListForRightCen{
				font-size: 14px !important;
				// width: calc(100vw - 60px);
			}
		}

	}
</style>